FiltersMdl.controller( 'CategoriesCtrl', [ '$scope', '$state', 'categories', 'category', 'HuesSrv', 'HuesUpdaterSrv', function ( $scope, $state, categories, category, HuesSrv, HuesUpdaterSrv ) {



	this.categories = categories;
	HuesSrv.setFilter('category', category );
	HuesSrv.setFilter('effect_fan', false );
	HuesSrv.setFilter('color_fan', false );
	HuesSrv.setFilter('subcategory', false );


	/**
	 * Handle active class color.
	 * Determined by the current category.
	 */
	var colors = ['yellow', 'pink', 'blue', 'green'];

	$scope.filters.current_color = colors[ categories.indexOf( category ) ];
	HuesUpdaterSrv.current_color = $scope.filters.current_color;

}]);